var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: _vm.timeout,
            color: _vm.color,
            outlined: _vm.outlined,
            top: "",
            right: "",
            shaped: "",
            elevation: "12",
          },
          model: {
            value: _vm.showToast,
            callback: function ($$v) {
              _vm.showToast = $$v
            },
            expression: "showToast",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center justify-space-between" },
            [
              _c(
                "div",
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(_vm._s(_vm.icon)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "body-2 pl-3" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.text))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _vm.link
                    ? _c(
                        "a",
                        { attrs: { href: _vm.link, target: "_blank" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "font-weight-bold mx-2",
                              attrs: { color: "primary lighten-5", text: "" },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.go")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.onCloseClick()
                        },
                      },
                    },
                    [_vm._v("close")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }